import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

/**
 * MultiSelectChips — pill chips for multi-choice questions (generalized from
 * the old areas step). Toggling persists immediately; the user advances with
 * the wizard footer when done.
 */
export default function MultiSelectChips({
  options = [],
  value = [],
  onChange,
  emptyMessage = "Nenhuma opção disponível.",
  tone = "cyan", // "cyan" | "destructive" (e.g. declined areas)
}) {
  if (options.length === 0) {
    return <p className="text-sm text-muted-foreground">{emptyMessage}</p>;
  }

  function toggle(id) {
    const next = value.includes(id) ? value.filter((v) => v !== id) : [...value, id];
    onChange(next);
  }

  return (
    <div className="flex flex-wrap gap-2" role="group">
      {options.map((opt) => {
        const active = value.includes(opt.id);
        return (
          <motion.button
            key={opt.id}
            type="button"
            aria-pressed={active}
            onClick={() => toggle(opt.id)}
            whileTap={{ scale: 0.96 }}
            className={cn(
              "rounded-full border px-4 py-2 text-sm font-medium transition-colors",
              active
                ? tone === "destructive"
                  ? "border-destructive bg-destructive/10 text-destructive"
                  : "border-cyan-500/70 bg-cyan-500/10 text-cyan-600 dark:text-cyan-400"
                : "border-border bg-surface text-muted-foreground hover:border-border-strong",
            )}
          >
            {opt.label}
          </motion.button>
        );
      })}
    </div>
  );
}
